import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import qs from 'query-string';
import qsFilters from 'qs';
import moment from 'moment';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, filterPayments, Consequence } from '../../libs/utils';

// Constants
import {
  PAYMENT_BASE,
  PAYMENT_SINGLE,
  PAYMENT_EXPORT,
  PAYMENT_REQUEST,
  PAY_ORDER_OXXO,
  PAYMENT_REP,
  PAYMENT_REP_CANCEL,
  PAYMENT_CANCEL_NOTIFY
} from '../../constants/endpoints';

import { getPackagesStats } from '../actions/permsActions';

export const CONFIRM_PAYMENT = 'CONFIRM_PAYMENT';
export const NEW_SINGLE_PAYMENT = 'NEW_SINGLE_PAYMENT';
export const NEW_PAYMENTS = 'NEW_PAYMENTS';
export const NEW_STATS_PAYMENTS = 'NEW_STATS_PAYMENTS';
export const NEW_PAYMENT = 'NEW_PAYMENT';
export const NEW_EXPORT_PAYMENTS = 'NEW_EXPORT_PAYMENTS';
export const NEW_REFERENCE = 'NEW_REFERENCE';
export const NEW_OXXO_REFERENCE = 'NEW_OXXO_REFERENCE';
export const NEW_PAYMENTS_FILTERS = 'NEW_PAYMENTS_FILTERS';
export const NEW_LOADING_TABLE = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING = 'NEW_SEARCHING';
export const NEW_VALUES_PAYMENTS = 'NEW_VALUES_PAYMENTS';
export const SET_INVOICE_ERROR = 'SET_INVOICE_ERROR';
export const CHANGE_PAYMENT_LOADING = 'CHANGE_PAYMENT_LOADING';

export function confirmPayment(data, isUnlimited) {
  return dispatch =>
    axios.post(PAYMENT_BASE, data).then(res => {
      const isRep = get(res, 'data.data.rep', false);

      if (!isUnlimited && isRep) {
        dispatch(getPackagesStats());
      }
      return thunkHandler(dispatch, get(res, 'data.data'), NEW_PAYMENT, 'ERROR');
    });
}

export function newPayment(invoice, callback) {
  return dispatch => {
    return Promise.resolve(invoice)
      .then(invoice => {
        if (typeof callback === 'function') callback(invoice);
        dispatch({ type: NEW_PAYMENT, payload: invoice });
      })
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
  }; // END return
} // END newPayment

export function newStats() {
  return dispatch =>
    Promise.resolve(invoices)
      .then(stats => dispatch({ type: NEW_STATS_PAYMENTS, payload: { filters_stats: stats } }))
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
}

export function newPayments(invoices, callback) {
  return dispatch => {
    return Promise.resolve(invoices)
      .then(invoices => {
        if (typeof callback === 'function') callback(invoices);
        dispatch({ type: NEW_PAYMENTS, payload: { page: invoices } });
      })
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
  }; // END return
} // END newPayments

export function getPayments(params) {
  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, sort, startDate, endDate, cancelToken } = params;

  if (activeTab) qsObj.status = filterPayments(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (sort) qsObj.sort = sort;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if

  return dispatch =>
    axios
      .get(`${PAYMENT_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PAYMENTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_PAYMENTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getPayments

export function exportPayments(params = {}) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate } = params;

  if (activeTab) qsObj.filter = filterPayments(activeTab);
  if (page) qsObj.page = params.page;
  if (code) qsObj.code = params.code;
  if (customer) qsObj.customer = params.customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if

  return dispatch =>
    axios
      .get(`${PAYMENT_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_PAYMENTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function getSinglePayment(uuid, callback) {
  return dispatch => {
    return axios
      .get(parseUrl(PAYMENT_SINGLE, { uuid }))
      .then(response => {
        const { data } = response.data;
        if (typeof callback === 'function') callback(data);
        dispatch({ type: NEW_SINGLE_PAYMENT, payload: data });
        return Promise.resolve(data);
      })
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
  }; // END return
} // END getSinglePayment

export function getPaymentReference(invoices) {
  return dispatch =>
    axios.post(PAYMENT_REQUEST, invoices).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: NEW_REFERENCE, error: 'ERROR' }
        })
    ); // END return
} // END getPaymentReference

export function getOxxoReference(reference) {
  return dispatch =>
    axios.post(PAY_ORDER_OXXO, reference).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: NEW_OXXO_REFERENCE, error: 'ERROR' }
        })
    ); // END return
} // END getOxxoReference

export function emitRep(uuid) {
  return dispatch =>
    axios.post(parseUrl(PAYMENT_REP, { uuid })).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: NEW_SINGLE_PAYMENT, error: 'ERROR' }
        })
    )
    .catch(error => {
      const errorData = error.response.data;
      const generalError = 'Ocurrió un error inesperado, por favor inténtalo mas tarde';

      if (errorData && errorData.key === 'external_service.dynamic.error') {
        const errorMessage = errorData.messageUser ? errorData.messageUser : generalError
        dispatch(setInvoiceError(errorMessage));
      } else if (errorData && errorData.message === 'Some invoices is not a CFDI') {
        dispatch(setInvoiceError('Para poder generar un REP, necesitas que todas las facturas asociadas al pago tengan CFDI'));
      } else if (errorData && errorData.key == 'external_service.time_zone_is_different_to_zipcode.error') {
        dispatch(setInvoiceError(errorData.messageUser));
      } else {
        dispatch(setInvoiceError(generalError));
      }
      return error
    });
} // END emitRep

export function cancelPayment(uuid) {
  return dispatch =>
    axios
      .delete(parseUrl(PAYMENT_REP_CANCEL, { uuid }))
      .then(() => axios.get(parseUrl(PAYMENT_SINGLE, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data') },
            eventTypes: { success: NEW_SINGLE_PAYMENT, error: 'ERROR' }
          })
      ); // END return
} // END

export function notifyCancelPaymemt(uuid, body) {
  return dispatch =>
    axios.post(parseUrl(PAYMENT_CANCEL_NOTIFY, { uuid }), body).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: NEW_SINGLE_PAYMENT, error: 'ERROR' }
        })
    ); // END return
} // END

export function getPaymentsVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Estado: {
      confirmed: false,
      pending: false,
      reject: false,
      cancel: false
    },
    Manual: {
      ar: false,
      xml: false,
      bar: false
    },
    Pasarela: {
      fiserv: false,
      oxxo_public: false,
      stp: false,
      stripe: false,
      conekta: false,
      spei: false,
      kushki: false,
      payfac: false,
      bank_sync: false
    },
    Comprobante: {
      1: false,
      2: false,
      3: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_PAYMENTS_FILTERS,
        payload: { filters, updateTable, searching }
      }),
      dispatch({
        type: NEW_VALUES_PAYMENTS,
        payload: initialValuesTags
      })
    );
} // END getPaymentsVisibilityFilters

export function updateLoadingTable(loadingTable) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_LOADING_TABLE,
        payload: loadingTable
      })
    );
} // END updateLoadingTable

export function getPaymentsV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${PAYMENT_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PAYMENTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_PAYMENTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getPaymentsV2

export function newExportPayments(allFilters) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${PAYMENT_EXPORT}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_PAYMENTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function resetSearching() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_SEARCHING,
        payload: false
      })
    );
} // END updateLoadingTable

export const setInvoiceError = message => {
  return dispatch =>
    dispatch({
      type: SET_INVOICE_ERROR,
      payload: {
        data: message
      }
    });
};

export const changePaymentLoading = data => ({
  type: CHANGE_PAYMENT_LOADING,
  payload: { data }
});


// WEBPACK FOOTER //
// ./src/redux/actions/paymentActions.js